import { defineMessages } from "./define.js";

/** The toast rail: offline, ready offline, and the update prompt. */
export const pwa = defineMessages("pwa", {
  offline: {
    ru: "Нет сети. Показано последнее, что успело загрузиться.",
    en: "No connection. Showing the last thing that loaded.",
  },
  offlineReady: {
    ru: "Приложение готово к работе офлайн.",
    en: "The app is ready to work offline.",
  },
  updateReady: { ru: "Доступна новая версия.", en: "A new version is available." },
  updateLater: { ru: "Позже", en: "Later" },
  update: { ru: "Обновить", en: "Update" },
  updating: { ru: "Обновляем…", en: "Updating…" },
});
